import { Component, OnInit } from '@angular/core';
import * as Sentry from "@sentry/angular";
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
@Sentry.TraceClassDecorator()
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
